import React, { useState } from 'react'
import Lightbox from 'react-image-lightbox'
import Icon from './photo-grid.svg'
import styles from './styles.css'

interface Props {
  images: string[]
}

const LightBox: React.SFC<Props> = ({ images }) => {
  const [photoIndex, onChangePhotoIndex] = useState(0)
  const [isOpen, toggleIsOpen] = useState(false)
  return (
    <>
      <button onClick={() => toggleIsOpen(true)} className={styles.mobileButton}>
        <Icon />
        Photos
      </button>

      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => toggleIsOpen(false)}
          onMovePrevRequest={() =>
            onChangePhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() => onChangePhotoIndex((photoIndex + 1) % images.length)}
          enableZoom={false}
          reactModalStyle={{ overlay: { zIndex: 100000 } }}
          imageTitle={`${photoIndex + 1}/${images.length}`}
        />
      )}
    </>
  )
}

export default LightBox
